module.exports = __webpack_public_path__ + "assets/1064b3042f20124ae297bd0607bd8996c2.jpg";